import { Skeleton } from '@/components/ui/skeleton'
import type { OverviewResponse } from '@/lib/metrics'
import { KpiTile } from '@/pages/dashboard/components/KpiTile'

interface Props {
  data?: OverviewResponse
  isLoading: boolean
}

export function KpiGrid({ data, isLoading }: Props) {
  if (isLoading || !data) {
    return (
      <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="h-32 space-y-3 rounded-2xl border bg-card p-4"
          >
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-8 w-24" />
            <Skeleton className="mt-auto h-6 w-full" />
          </div>
        ))}
      </div>
    )
  }
  return (
    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {data.tiles.map((tile, i) => (
        <KpiTile key={tile.key} tile={tile} index={i} />
      ))}
    </div>
  )
}
